import React, { useReducer } from 'react';
import { DocumentsModalScrollInfo } from '../documentsModal/DocumentsModalScrollInfo';

export const useScrollInfoModal = ({ onClickCancelButton }) => {
    const initialState = {
        scrollInfoModalShow: false,
        scrollInfoModalShowed: false,
    };
    const [{ scrollInfoModalShow, scrollInfoModalShowed }, dispatch] = useReducer((prev, next) => {
        return { ...prev, ...next };
    }, initialState);

    const handleClickCancelButtonModalScrollInfo = e => {
        e.preventDefault();
        dispatch({ scrollInfoModalShow: false });
        onClickCancelButton(e);
    };
    const handleClickContinueButtonModalScrollInfo = e => {
        e.preventDefault();
        dispatch({ scrollInfoModalShow: false });
    };
    const handleClickCloseButtonModalScrollInfo = e => {
        e.preventDefault();
        dispatch({ scrollInfoModalShow: false });
    };

    const handleClickGif = e => {
        e.preventDefault();
    };

    const openScrollInfoModal = tagEvent => {
        dispatch({ scrollInfoModalShowed: true, scrollInfoModalShow: true });
    };

    const renderScrollInfoModal = () => {
        if (!scrollInfoModalShow) return null;

        return (
            <DocumentsModalScrollInfo
                handleClickCloseButton={handleClickCloseButtonModalScrollInfo}
                handleClickGif={handleClickGif}
                handleClickCancelButton={handleClickCancelButtonModalScrollInfo}
                handleClickContinueButton={handleClickContinueButtonModalScrollInfo}
            />
        );
    };

    return { scrollInfoModalShow, scrollInfoModalShowed, renderScrollInfoModal, openScrollInfoModal };
};
